<div #mechanic class="wk8-wisselklanken relative h-full" style="position: relative; margin-left: 15%; height: 100%">
  <wk8-pipe-back class="absolute top-[24%] right-[15%] h-[45%] translate-x-full" />
  <wk8-conveyor-belt class="absolute top-[55%] block h-[8%] w-[90%]" />

  <div class="absolute right-[15%] bottom-[44.5%] w-4/5">
    <div
      class="papers"
      wk8ReadFocus
      style="display: grid; grid-auto-flow: column; gap: 1%; justify-content: center; margin-right: 25%; transition: translate 2s ease-in"
      [style]="{
        translate: isMovingIntoPipe() ? '100vw 0' : undefined,
      }"
    >
      @for (paper of papers(); track $index) {
        <div
          class="paper"
          style="transition: translate 0.5s var(--ease-in-out-back); position: relative; user-select: none; cursor: pointer"
          [style.font-size.px]="fontSize()"
          (click)="correct().includes($index) || _wk8TutorService.isChecking() || isSwapping() ? undefined : swapIndex($index)"
        >
          <div class="hitbox" style="position: absolute; inset: 0; top: -55%"></div>
          <div
            #paper
            (dragstart)="(false)"
            [style]="{
              transition: `transform 0.25s var(--ease-in-out-back)`
            }"
          >
            <wk8-paper-piece padding="SMALL">{{ paper }}</wk8-paper-piece>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="hooks" style="position: absolute">
    @for (paper of papers(); track $index) {
      @let isPinned = pinned().includes($index);
      @let isCorrect = correct().includes($index);
      <div #hook class="claw-wrapper claw-visible" style="display: inline-block">
        <div
          class="claw"
          [style]="{
            transition: 'translate 0.25s var(--ease-in-out-back), transform 0.25s var(--ease-in-out-back)',
            translate: '0px ' + (isPinned ? '-32px' : '0px'),
          }"
        >
          <wk8-claw-back [opened]="isPinned" [size]="clawSize()" />
          <wk8-claw-front
            [opened]="isPinned"
            [size]="clawSize()"
            [lightColor]="isCorrect ? 'green' : isPinned || isSwapping() ? 'none' : 'orange'"
          />
        </div>
      </div>
    }
  </div>
  <wk8-pipe-front class="absolute top-[24%] right-[15%] h-[45%] translate-x-full" />

  @if (hasCompletedReadCheck()) {
    <wk8-screen
      class="absolute right-0 bottom-0 -mr-1 -mb-2 h-2/5 w-[55%] -skew-1 transition-all duration-500"
      [style.opacity]="showScreenAnim() ? 1 : 0"
      [style.transform]="showScreenAnim() ? 'translateY(0)' : 'translateY(40px)'"
      [submitButton]="isSwapping() || isWrong() || _wk8TutorService.isChecking() || isChecking() ? 'disabled' : 'default'"
      [swapButton]="'hidden'"
      (submitted)="check()"
    >
      <wk8-panel-image #panelImage [word]="targetWord()" style="display: block; width: 100%; height: 100%" />
    </wk8-screen>
  }
</div>
